module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body full-height mt-30 p-2-12"
  }, [_c('div', {
    staticClass: "table-row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "table-from"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.announcement.title),
      expression: "announcement.title"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "標題最多100字",
      "maxlength": "100",
      "type": "text"
    },
    domProps: {
      "value": (_vm.announcement.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.announcement, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "table-from"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.announcement.content),
      expression: "announcement.content"
    }],
    staticClass: "form-control",
    attrs: {
      "cols": "30",
      "rows": "10",
      "type": "text",
      "placeholder": "內文最多500字",
      "maxlength": "500"
    },
    domProps: {
      "value": (_vm.announcement.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.announcement, "content", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "table-from w-100"
  }, [_c('date-picker', {
    staticClass: "hide-date-icon",
    attrs: {
      "show-second": false,
      "type": "datetime",
      "valueType": "format",
      "format": "YYYY-MM-DD HH:mm:ss",
      "input-class": "form-control",
      "clearable": false,
      "disabled-time": _vm.notBeforeNow,
      "disabled-date": _vm.notBeforeToday
    },
    model: {
      value: (_vm.formTime.time),
      callback: function($$v) {
        _vm.$set(_vm.formTime, "time", $$v)
      },
      expression: "formTime.time"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "table-from"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.announcement.role_type),
      expression: "announcement.role_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.announcement, "role_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("不限")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Admin")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Brand")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Store")])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "table-from"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.announcement.is_overlay),
      expression: "announcement.is_overlay"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.announcement, "is_overlay", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("不啟用")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("啟用")])])])]), _vm._v(" "), (_vm.$route.name === 'editAnnouncement') ? _c('div', {
    staticClass: "table-row"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "table-from"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.announcement.republish),
      expression: "announcement.republish"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.announcement, "republish", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("是")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-left mt-64"
  }, [_c('button', {
    staticClass: "btn btn-success btn_add",
    on: {
      "click": function($event) {
        return _vm.addimg()
      }
    }
  }, [_vm._v("新增圖片")])]), _vm._v(" "), (_vm.img_view) ? _c('div', {
    staticClass: "m-t-10 form-control"
  }, _vm._l((_vm.img_list), function(img, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (img.image_name !== 'delete'),
        expression: "img.image_name !== 'delete'"
      }],
      staticClass: "m-y-20"
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon input-img-title"
    }, [_vm._v("\n                圖片 " + _vm._s(index + 1) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "input-group-addon w-100-p text-center p-all-0 bg-white",
      staticStyle: {
        "border-right": "none"
      }
    }, [_c('span', {
      staticClass: "inline-block h-auto m-t-5"
    }, [(!img.image_name) ? _c('div', {
      staticClass: "text-black",
      domProps: {
        "textContent": _vm._s('沒有圖片')
      }
    }) : _vm._e(), _vm._v(" "), (img.image_name) ? _c('img', {
      staticClass: "h-auto img-responsive",
      attrs: {
        "src": img.image_name,
        "data-toggle": "modal"
      }
    }) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "form-control h-100"
    }, [_c('label', {
      staticClass: "btn-upload btn btn-default",
      staticStyle: {
        "margin-top": "25px"
      },
      attrs: {
        "for": 'img-' + index
      },
      on: {
        "click": function($event) {
          return _vm.onFileChangeBtn(index)
        }
      }
    }, [_vm._v("\n                  選擇圖片\n                ")]), _vm._v(" "), _c('input', {
      staticClass: "form-control",
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "type": "file",
        "id": 'img-' + index
      },
      on: {
        "change": _vm.onFileChange
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "input-group-addon w-100-p text-center bg-white p-0-32"
    }, [_c('div', {
      staticClass: "btn btn-danger",
      attrs: {
        "data-toggle": "modal"
      },
      on: {
        "click": function($event) {
          return _vm.del_img(_vm.img_list, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "text-right text-15 text-red"
    }, [_vm._v("圖片大小為 寬不限制x高330  512KB 內")])])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-left mt-64"
  }, [_c('button', {
    staticClass: "btn btn-success btn_add",
    on: {
      "click": function($event) {
        return _vm.addurl()
      }
    }
  }, [_vm._v("新增連結")])]), _vm._v(" "), (_vm.url_list && _vm.url_list.length > 0) ? _c('div', {
    staticClass: "m-t-10 form-control"
  }, _vm._l((_vm.url_list), function(url, index) {
    return _c('div', [_c('div', {
      staticClass: "input-group m-y-20"
    }, [_c('span', {
      staticClass: "input-group-addon input-url-title"
    }, [_c('span', {
      staticClass: "text-red"
    }, [_vm._v("＊ ")]), _vm._v("\n                連結 " + _vm._s(index + 1) + "\n              ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.url_list[index]),
        expression: "url_list[index]"
      }],
      staticClass: "form-control url-input",
      attrs: {
        "placeholder": "網站連結",
        "type": "text",
        "maxlength": "1000"
      },
      domProps: {
        "value": (_vm.url_list[index])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.url_list, index, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "input-group-addon text-center bg-white"
    }, [_c('div', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.del_url(_vm.url_list, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center mt-64"
  }, [_c('router-link', {
    attrs: {
      "to": "/announcement"
    }
  }, [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("\n          取消\n        ")])]), _vm._v(" "), (_vm.$route.name === 'addAnnouncement') ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.updataAll('add')
      }
    }
  }, [_vm._v("\n        新增\n      ")]) : _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.updataAll('up')
      }
    }
  }, [_vm._v("\n        修改\n      ")])], 1)]), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.delDesAlisOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "del-block m-t-15"
  }, [_c('div', {
    staticClass: "btn btn-danger",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delNewsModal"
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-cell"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("標題\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-cell"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("內文說明\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-cell"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("發佈時間\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-cell"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("發佈對象\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-cell"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("蓋板開關\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-cell"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("重新發佈\n        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39c50a89"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Announcement/components/AnnouncementForm.vue
// module id = 2382
// module chunks = 1